var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "integrations-view", tag: "section" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12", sm: "8", md: "6" } }, [
                    _vm._v(" " + _vm._s(_vm.$t("integrations.title")) + " ")
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-sm-right",
                      attrs: { cols: "12", sm: "4", md: "6" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: { click: _vm.createItemDialog }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("integrations.create")) + " "
                          )
                        ]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary" },
                          on: { click: _vm.showParamsGenerator }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("integrations.button.parameters")) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary" },
                          on: { click: _vm.refreshItems }
                        },
                        [_c("v-icon", [_vm._v("mdi-refresh")])],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  loading: _vm.loading,
                  items: _vm.integrations,
                  "items-per-page": 25
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.actions",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          {
                                            staticClass: "mr-2",
                                            on: {
                                              click: function($event) {
                                                _vm.viewPublicKey = true
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [_vm._v(" mdi-eye ")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("integrations.view-pk")))
                            ])
                          ]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          {
                                            staticClass: "mr-2",
                                            on: {
                                              click: function($event) {
                                                return _vm.editItem(item)
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [_vm._v(" mdi-pencil-outline ")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.$t("edit")))])]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          {
                                            on: {
                                              click: function($event) {
                                                return _vm.deleteItem(item)
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [_vm._v(" mdi-delete-outline ")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.$t("delete")))])]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "600px" },
              model: {
                value: _vm.paramsGeneratorVisible,
                callback: function($$v) {
                  _vm.paramsGeneratorVisible = $$v
                },
                expression: "paramsGeneratorVisible"
              }
            },
            [
              _c("params-generator", {
                ref: "paramsGenerator",
                on: { cancel: _vm.hideParamsGenerator }
              })
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "600px" },
              model: {
                value: _vm.editDialogVisible,
                callback: function($$v) {
                  _vm.editDialogVisible = $$v
                },
                expression: "editDialogVisible"
              }
            },
            [
              _vm.editDialogVisible
                ? _c("edit-integration", {
                    ref: "integrationEditDialog",
                    attrs: { id: _vm.editedItemId, model: _vm.editedItem },
                    on: {
                      cancel: _vm.closeEditDialog,
                      save: _vm.saveEditDialog
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "600px" },
              model: {
                value: _vm.viewPublicKey,
                callback: function($$v) {
                  _vm.viewPublicKey = $$v
                },
                expression: "viewPublicKey"
              }
            },
            [
              _c(
                "div",
                [
                  _c(
                    "v-container",
                    { attrs: { id: "classCreate" } },
                    [
                      _c(
                        "v-card",
                        { attrs: { "max-width": "800px" } },
                        [
                          _c("v-card-title", [
                            _vm._v(_vm._s(_vm.$t("integrations.public-key")))
                          ]),
                          _c("v-card-text", [
                            _c("pre", [_vm._v(_vm._s(_vm.publicKey))])
                          ]),
                          _c(
                            "v-card-actions",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "blue darken-1" },
                                  on: {
                                    click: function($event) {
                                      _vm.viewPublicKey = false
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("global.cancel")) + " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }